
<script>
// 0,0 ist links oben
const hour_height = 20 // dy einer Stunde im Canvas (in Pixel)

let scrolling = false
let y_scroll_saved = 0
let y_scroll_start = 0
let y_scroll = 0
let height_required_by_time = 0
let height_required_by_text = 0
let textbox_koords = Array
let schritte_linien = Array
let clicked_text = -1

export let schritte = []
export let farbe = "blue"

let canvas // bind:this auf canvas-Element
let textContainer // bind:this auf div-Element

//$: schritte && make_everything_new() // watch schritte und führe ggf. Funktion aus

import { onMount } from 'svelte';

onMount( () => {
    make_everything_new();
    window.addEventListener("resize", make_everything_new );  // hier keine Klammer nach der Funktion!!!
  })

export function make_everything_new() {

  write_text_and_store_area() // berechnet außerdem height_required_by_text
  prepare_termin_linien() // berechnet außerdem height_required_by_time
  // y-Wert der untersten Textbox ODER der untersten Terminlinie bestimmen ( und noch etwas vergrößern)
  canvas.height = Math.max(height_required_by_text, height_required_by_time) + 3*hour_height
  draw_timetable()
}

function write_text_and_store_area() { // erstellt die Beschreibung
  textContainer.innerHTML = ""
  textbox_koords = [] // Text-Koordinaten für Abgleich beim Click-Event
  var text_mittelpunkte_y = []
  if (schritte === null) schritte = []
  for (let i=0; i<schritte.length; i++) {
    var textDiv = document.createElement("div")
    textDiv.classList.add('divText')
    textDiv.style.borderLeftColor = farbe;
    if (i===clicked_text) textDiv.style.borderLeft = '5px solid red'
    var textNode = document.createTextNode(schritte[i][1])
    textDiv.appendChild(textNode)
    textContainer.appendChild(textDiv);
    var textKoords = textDiv.getBoundingClientRect() // funktioniert nicht wenn die Komponente mit display='none' gestartet wird !
    textbox_koords.push(textKoords)
    text_mittelpunkte_y.push( (textKoords.top+textKoords.bottom)/2 )
  }
  var y0 = textContainer.getBoundingClientRect().top
  var y_text_unten = Math.max(...text_mittelpunkte_y)
  height_required_by_text = Math.ceil(y_text_unten-y0)
}


function draw_timetable () {

  var ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.strokeStyle = "gray";
  ctx.lineWidth = 0.5;
  ctx.fillStyle = "black";

  // Konstanten definieren
  const xl_kalender = 30 // Anfang der Kalender-Linien (pixel)
  const xr_kalender = 90 // Ende der Kalender-Linie (pixel)
  const xl_event = xl_kalender+5 // Anfang Termin-Linie (pixel)
  const xr_event = xl_kalender+25 // Ende Termin-Linie (pixel)
  const xl_jetzt = xl_kalender-5 // Anfang Grüne Linie (pixel)
  const xr_jetzt = xr_kalender+5 // Ende Grüne Linie (pixel)

  const night_start = 23; // Uhrzeit
  const night_end = 7; // Uhrzeit

  const h_ms = 60*60*1000; // eine Stunde hat soviele Millisekunden

  // Nacht-Markierung vorbereiten
  if (night_end<night_start) {
    var night_length = night_end+24-night_start
  }
  else {
    var night_length = night_end-night_start
  }
  var night_hours = []
  for (let i=night_start; i<night_start+night_length; i++) { // aus 22->7 soll [23,0,1,2,..,7] werden
    night_hours.push(i%24)
  }

  var date_now = new Date(); // Kalender soll oben bei aktuellem Datum anfangen ...
  var scroll_h = y_scroll/hour_height;
  var t_oben = date_now.getTime();
  t_oben += -1.5*h_ms; // ... aber 1.5h über der "jetzt"-Linie anfangen zu zeichnen ...
  t_oben += -scroll_h*h_ms; // ... und Drag-Wunsch des Users berücksichtigen

  // Kalender-Striche und Stunden zeichnen
  var canvas_hours = canvas.height/hour_height; // wieviele Stunden können in der Kalenderansicht dargestellt werden
  for (let i=0; i<=canvas_hours; i++) {
    // Datum von oberer Begrenzung nehmen, auf volle Stunden runden und volle Stunden dazuaddieren
    var date_i = new Date(t_oben);
    date_i.setMinutes(0);
    date_i.setSeconds(0);
    var stunde_in = date_i.getHours() + i; // z.B. 25
    date_i.setHours(stunde_in);
    var stunde_out = date_i.getHours(); // z.B. 1
    // Datum in Pixel umwandeln, waagrechte Striche zeichnen und Stunde hinschreiben
    var y = t2y(date_i.getTime(), t_oben);
    horizontal_line(ctx, xl_kalender,xr_kalender,y, 0.5, 'gray');
    if (stunde_out != 0)
      ctx.fillText(stunde_out, 5, y+3);
    // Prüfen, ob bei einem der Striche ein neuer Tag anfängt
    if (stunde_out == 0) {
      horizontal_line(ctx, 0, canvas.width,y, 2);
      let weekday = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'][date_i.getDay()];
      ctx.fillText(weekday, 5, y-3);
    }

    // Nacht markieren
    if (night_hours.includes(stunde_out)) {
      ctx.fillStyle = "silver";
      ctx.globalAlpha = 0.5;
      ctx.fillRect(xl_kalender, y, xr_kalender-xl_kalender, hour_height); //context.fillRect(x, y, width, height);
      ctx.globalAlpha = 1;
      ctx.fillStyle = "black";
    }
  }

  // aktuelle Zeit als grüne Linie
  var y_jetzt = t2y(date_now.getTime(), t_oben)
  horizontal_line(ctx, xl_jetzt,xr_jetzt,y_jetzt, 0.7, 'green');

  // Termine als Linien einzeichnen und mit den vorhandenen Texten verbinden
  var y_top = textContainer.getBoundingClientRect().top
  for (let i=0; i<schritte.length; i++) {
    var y_termin = schritte_linien[i] + 1.2*hour_height // den ersten Termin mit Abstand von 1,2 Stunden von oben einzeichnen
    // Waagrechter Strich, um Event zu markieren
    if (i===clicked_text) horizontal_line(ctx, xl_event, xr_event, y_termin, 1, 'red');
    else horizontal_line(ctx, xl_event, xr_event, y_termin, 0.5, farbe);
    // Koordinaten der Textboxen auslesen
    var rect_text = textbox_koords[i]
    var y_text = (rect_text.top+rect_text.bottom)/2
    // Schräge Linien zwischen Kalendermarkierung und Beschreibung
    ctx.beginPath();
    ctx.moveTo(xr_event, y_termin);
    ctx.lineTo(canvas.width, y_text-y_top); // die Linie immer bis zum Rand des Canvas zeichnen
    if (i===clicked_text) ctx.strokeStyle = "red";
    else ctx.strokeStyle = farbe;
    ctx.lineWidth = 0.5;
    ctx.stroke();
  }

}


function prepare_termin_linien() {
schritte_linien = []
for (let i=0; i<schritte.length; i++) {
  var delta_h = schritte[i][0]; // Abstand zur grünen Linie(=Jetzt), NICHT zum Kalenderanfang!
  schritte_linien.push(hour_height*delta_h)
}
height_required_by_time = Math.ceil(Math.max(...schritte_linien))
}


function t2y (t, t_oben) { // wandelt Unix-Zeit (in ms) in y-Offset (in Pixeln) um
var diff_ms = t - t_oben;
var y = diff_ms/1000/3600 * hour_height;
return y
}

function horizontal_line (ctx, xl,xr,y, lw=1, color="black") {
ctx.beginPath();
ctx.moveTo(xl, y);
ctx.lineTo(xr, y);
ctx.strokeStyle = color;
ctx.lineWidth = lw;
ctx.stroke();
}

function textclick(e) {
  for (let i=0; i<textbox_koords.length; i++) {
    var yo = textbox_koords[i].top
    var yu = textbox_koords[i].bottom
    var xl = textbox_koords[i].left
    var xr = textbox_koords[i].right
    var yclicked = e.clientY
    var xclicked = e.clientX
    if (yclicked >= yo && yclicked <= yu && xclicked >= xl && xclicked <= xr) {
      clicked_text = i
      write_text_and_store_area()
      draw_timetable();
    }
  }
}

function startdragging(e, touch) {
  if (touch == true) {var e = e.changedTouches[0];}
  y_scroll_start = e.clientY
  scrolling = true
  make_everything_new()
}

function stopdragging(e, touch) {
  if (touch == true) {var e = e.changedTouches[0];}
  scrolling = false
  y_scroll_saved = y_scroll_saved - (y_scroll_start - e.clientY)
}

function duringdragging(e, touch) {
  if (touch == true) {var e = e.changedTouches[0];}
   if (scrolling == true) {
     y_scroll = y_scroll_saved - y_scroll_start + e.clientY
     draw_timetable()
     }
}

</script>



<div style="display:flex; justify-content:flex-start" on:mousedown={event => textclick(event)}>

    <canvas
      bind:this={canvas}
      width="120"
      height="300"
      on:mousedown={event => startdragging(event,false)}
      on:mouseup={event => stopdragging(event,false)}
      on:mousemove={event => duringdragging(event,false)}
      on:touchstart={event => startdragging(event,true)}
      on:touchend={event => stopdragging(event,true)}
      on:touchmove={event => duringdragging(event,true)}
      style="touch-action: none;"
      >
    canvas not supported
  </canvas>

<div style="">
  <div bind:this={textContainer} style="text-align:left; font-size:small; display:inline-block; vertical-align:top;"></div>
</div>

</div> <!-- row -->


<style>
  :global(.divText) { /*wenn nicht global, dann wirft Svelte die Klasse raus, weil sie nur zur Laufzeit hinzugefügt wird */
    margin-bottom: 5px;
    padding: 1px;
    border-left-width: 5px;
    border-left-style: solid;
    /* borderLeft = '5px solid blue' */
  }



</style>
